import React from 'react'
import { FiHeadphones, FiInstagram} from 'react-icons/fi'

type Props = {
  className: string,
}
const Support: React.FC<Props> = ({className}) => {
  return (
    <div className={`card bg-light-grad ${className}`}>
      {/* begin::Body */}
      <div className='card-body p-0'>
        {/* begin::Header */}
        <div className={`px-9 pt-7 card-rounded h-150px w-100 `}>
          {/* begin::Heading */}
          <div dir={'rtl'} className='d-flex items-center'>
            <div style={{borderRadius: 10}} className={'bg-white p-2'}>
              <FiHeadphones  color={'#D71543FF'} size={50} />
            </div>
            <div className={'mr-5 flex flex-col'}>
              <div>
                <h4 className={'text-white'}>              مشاوره تلفنی  پاسخگویی سوالات شما</h4>
              </div>
              <div>
                پاسخگوی سریع سوالات
              </div>
            </div>
          </div>
          <div className={'mt-4 text-center'}>
            <h4 className={'text-white'}>021-53457000</h4>
          </div>
        </div>
        <div  className={'flex p-5 gs-morphism justify-around'}>
          <div>
            <a target='_blank' href='https://www.instagram.com/miphospital/' rel="noreferrer">
              <FiInstagram color={'white'} size={30} />
            </a>
          </div>
          <div style={{ borderRight: '2px solid white' }}/>
          <div>
            <a target='_blank' href='https://web.whatsapp.com/send?phone=98919419-+9420' rel="noreferrer">
              {/* <FaWhatsapp color={'white'} size={30}/> */}
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support